export const getCompetitionDate = (date: Date | undefined, language: string) => {

    if (!date || ( date && date.toString()?.includes('Invalid Date') )) return '';

    const day = date?.toLocaleDateString(language, { day: "numeric" })
    const month = date?.toLocaleDateString(language, { month: "numeric" })
    const year = date?.toLocaleDateString(language, { year: "numeric" })

    return `${Number(day) < 10 ? '0' + day : day}.${Number(month) < 10 ? '0' + month : month}.${year}`
}export const getCompetitionDate = (date: Date | undefined, language: string) => {

    if (!date || ( date && date.toString()?.includes('Invalid Date') )) return '';

    const day = date?.toLocaleDateString(language, { day: "numeric" })
    const month = date?.toLocaleDateString(language, { month: "numeric" })
    const year = date?.toLocaleDateString(language, { year: "numeric" })

    return `${Number(day) < 10 ? '0' + day : day}.${Number(month) < 10 ? '0' + month : month}.${year}`
}